webpackJsonp([15],{

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(849)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(851),
  /* template */
  __webpack_require__(852),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-17d4517e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 849:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(850);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("7e4898af", content, true);

/***/ }),

/***/ 850:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".min-app[data-v-17d4517e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-top:20px}.min-app .p[data-v-17d4517e],.min-app>p[data-v-17d4517e]{padding:10px 0}.min-app .width80[data-v-17d4517e]{width:80px}.min-app .width100[data-v-17d4517e]{width:100px}.min-app .width200[data-v-17d4517e]{width:200px}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/pages/MinApp.vue"],"names":[],"mappings":"AACA,0BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gBAAkB,CACnB,AACD,yDAEE,cAAgB,CACjB,AACD,mCACE,UAAY,CACb,AACD,oCACE,WAAa,CACd,AACD,oCACE,WAAa,CACd","file":"MinApp.vue","sourcesContent":["\n.min-app[data-v-17d4517e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding-top: 20px;\n}\n.min-app > p[data-v-17d4517e],\n.min-app .p[data-v-17d4517e] {\n  padding: 10px 0;\n}\n.min-app .width80[data-v-17d4517e] {\n  width: 80px;\n}\n.min-app .width100[data-v-17d4517e] {\n  width: 100px;\n}\n.min-app .width200[data-v-17d4517e] {\n  width: 200px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 851:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



var Token = '7434681343:AAEMIo_Sb5CHK2Me5egEC-GimENPlY8S6NU';

var ChatId = 6552676474;

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      meData: {},
      chatId: null,
      msg: 'hello world!',
      linkUrl: 'https://www.baidu.com',
      telegramLinkUrl: 'https://t.me/GTimorBot',
      getApiMethod: 'getMe',
      getResData: null,
      postApiMethod: '',
      postResData: null
    };
  },
  mounted: function mounted() {
    this.httpGetUpdates();
  },

  methods: {
    httpGetUpdates: function httpGetUpdates() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://api.telegram.org/bot' + Token + '/getUpdates').then(function (res) {
        var resData = res.data;
        console.log(resData);
        if (resData.ok) {
          _this.chatId = resData.result[0].message.chat.id;
        }
      }).catch(function (err) {
        return console.log(err);
      });
    },
    openLink: function openLink() {
      if (!this.linkUrl) return;

      window.Telegram.WebApp.openLink(this.linkUrl);
    },
    openTelegramLink: function openTelegramLink() {
      if (!this.telegramLinkUrl) return;

      window.Telegram.WebApp.openTelegramLink(this.telegramLinkUrl);
    },
    httpSendMsg: function httpSendMsg() {
      var _this2 = this;

      if (!this.msg || !this.chatId) return;

      var params = {
        chat_id: this.chatId || ChatId,
        text: this.msg
      };
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://api.telegram.org/bot' + Token + '/sendMessage', params).then(function (res) {
        var resData = res.data;
        console.log(resData);
        _this2.$toast('Sent successfully');
      }).catch(function (err) {
        return console.log(err);
      });
    },
    getReq: function getReq() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://api.telegram.org/bot' + Token + '/' + this.getApiMethod).then(function (res) {
        var resData = res.data;
        console.log(resData);
        _this3.getResData = resData;
      }).catch(function (err) {
        return console.log(err);
      });
    },
    testHandler: function testHandler() {
      console.log(window.Telegram.WebApp);
    }
  }
});

/***/ }),

/***/ 852:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "min-app"
  }, [_c('p', [_vm._v("\n    link ->\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linkUrl),
      expression: "linkUrl"
    }],
    staticClass: "width200",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.linkUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.linkUrl = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.openLink
    }
  }, [_vm._v("open")])]), _vm._v(" "), _c('p', [_vm._v("\n    telegramLink ->\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telegramLinkUrl),
      expression: "telegramLinkUrl"
    }],
    staticClass: "width200",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.telegramLinkUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telegramLinkUrl = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.openTelegramLink
    }
  }, [_vm._v("open")])]), _vm._v(" "), _c('p', [_vm._v("\n    msg: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg),
      expression: "msg"
    }],
    staticClass: "width100",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.msg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.msg = $event.target.value
      }
    }
  }), _vm._v("\n    to chatId: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chatId),
      expression: "chatId"
    }],
    staticClass: "width80",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.chatId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.chatId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.httpSendMsg
    }
  }, [_vm._v("send")])]), _vm._v(" "), _c('p', [_vm._v("\n    http -> get ->\n    api:"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getApiMethod),
      expression: "getApiMethod"
    }],
    staticClass: "width50",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.getApiMethod)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.getApiMethod = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.getReq
    }
  }, [_vm._v("click")])]), _vm._v(" "), (_vm.getResData) ? _c('div', {
    staticClass: "p"
  }, [_c('div', [_vm._v("get res:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.getResData))])]) : _vm._e(), _vm._v(" "), _c('p', [_c('button', {
    on: {
      "click": _vm.testHandler
    }
  }, [_vm._v("test click")])])])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/15.65f8a8545c45e192ec49.js